import { z } from 'zod';

export const LocalDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be a YYYY-MM-DD date');

export const StreakSchema = z.object({
  current: z.number().int().min(0),
  longest: z.number().int().min(0),
  freezesLeft: z.number().int().min(0),
  activeToday: z.boolean(),
});
export type Streak = z.infer<typeof StreakSchema>;

/**
 * One test result, as produced by the runner and stored with an attempt.
 * `message` is the text to show (the test's custom message when it has one); `detail` is the raw assertion
 * text ("Expected 3, received 2") when a custom message replaced it.
 */
export const TestResultSchema = z.strictObject({
  name: z.string().min(1).max(200),
  passed: z.boolean(),
  message: z.string().max(500).optional(),
  detail: z.string().max(500).optional(),
});
export type TestResult = z.infer<typeof TestResultSchema>;

export const ChallengeIdParamsSchema = z.strictObject({
  challengeId: z.string().regex(/^[a-z0-9-]{1,80}$/, 'Unknown challenge'),
});

export const TrackSlugParamsSchema = z.strictObject({
  trackSlug: z.string().regex(/^[a-z0-9-]{1,80}$/, 'Unknown track'),
});

export const ReviewIdParamsSchema = z.strictObject({
  reviewId: z.uuid('Unknown review'),
});

export function isValidTimeZone(tz: string): boolean {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: tz });
    return true;
  } catch {
    return false;
  }
}

export const TimeZoneSchema = z.string().min(1).max(64).refine(isValidTimeZone, 'Unknown time zone');
